import { api } from './client'

/** A file on a deal or a contact. */
export interface Attachment {
  id: string
  filename: string
  contentType: string | null
  size: number
  uploadedBy: string | null
  uploadedByName: string | null
  createdAt: string
}

export type AttachmentTarget = { kind: 'deal' | 'contact'; id: string }

const base = (t: AttachmentTarget) => `/api/${t.kind === 'deal' ? 'deals' : 'contacts'}/${t.id}/attachments`

export async function listAttachments(t: AttachmentTarget): Promise<Attachment[]> {
  return (await api.get<Attachment[]>(base(t))).data
}

export async function uploadAttachment(t: AttachmentTarget, file: File): Promise<Attachment> {
  const form = new FormData()
  form.append('file', file)
  // Null the default JSON content type so the browser sets multipart + boundary (as uploadFile does).
  return (await api.post<Attachment>(base(t), form, { headers: { 'Content-Type': null } })).data
}

export async function attachmentUrl(id: string): Promise<string> {
  return (await api.get<{ url: string }>(`/api/attachments/${id}/url`)).data.url
}

/** Make one of the deal's photos its cover; null removes the cover. */
export async function setDealCover(dealId: string, attachmentId: string | null): Promise<{ coverAttachmentId: string | null; coverUrl: string | null }> {
  return (await api.put(`/api/deals/${dealId}/cover`, { attachmentId })).data
}

export async function deleteAttachment(id: string): Promise<void> {
  await api.delete(`/api/attachments/${id}`)
}
